import { Injectable } from '@angular/core';
import { EProcessStatus, IProcessDto } from 'core/dto';
import { Observable, map } from 'rxjs';
import { ApiService } from '../api.service';
import { controllerEndpoints } from '../controller.endpoints';
import joinUrls from '../utils.ts/join-urls';
import { ICrudBasicMethods } from './types/i-crud-basic.methods';

type ExtendedProcessDto = {
  id: string,
  title: string,
  created: Date,
  activityCount: number,
  documentCount: number,
  creator: string
}


@Injectable({
  providedIn: 'root'
})
export class ProcessRemoteControllerService implements ICrudBasicMethods<IProcessDto> {

  private readonly _endpoint = controllerEndpoints.PROCESS

  private readonly FINISH = 'finish';
  private readonly GET_BY_CRITERIA = 'getByCriteria';
  private readonly CANCEL = 'cancel';
  private readonly EXTEND_VALIDITY = 'extendValidity'

  constructor(
    private readonly _apiService: ApiService

  ) {

  }

  getOne(id: string): Observable<IProcessDto> {

    const getOneEndpoint = joinUrls(this._endpoint, id)
    return this._apiService.get<IProcessDto>(getOneEndpoint)
      .pipe(map((process) => ({ ...process })))
  }

  update(id: string, updateDto: Partial<IProcessDto>): Observable<IProcessDto> {
    const updateEndpoint = joinUrls(this._endpoint, id);
    return this._apiService.put(updateEndpoint, updateDto)
  }

  create(createDto: Partial<IProcessDto>): Observable<IProcessDto> {
    return this._apiService.post(this._endpoint, createDto)
  }

  remove(id: string): Observable<undefined> {
    const endpoint = joinUrls(this._endpoint, id)
    return this._apiService.delete<undefined>(endpoint);
  }

  finishProcess(id: string) {
    const finishEndpoint = joinUrls(this._endpoint, this.FINISH, id);
    return this._apiService.put(finishEndpoint);
  }

  getMany(params: { page: number, size: number, status?: EProcessStatus, description?: string, creator?: string, note?: string }) {

    return this._apiService.get<{ data: IProcessDto[], totalCount: number }>(joinUrls(this._endpoint, this.GET_BY_CRITERIA), params);

  }

  extendValidity(id: string, validTill: Date) {
    return this._apiService.put<any>(joinUrls(this._endpoint, this.EXTEND_VALIDITY, id), null, { validTill: validTill.toISOString() });
  }

  cancel(id: string) {
    const cancelEndpoint = joinUrls(this._endpoint, this.CANCEL, id);
    return this._apiService.put(cancelEndpoint);
  }

  subscribeToStatusChange() {

  }
}
